import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { observer, inject } from "mobx-react";
import lodashGet from "lodash.get";
import { HEADER, pageType } from "npmlinks-constants";
import { Utils, Button, Modal, Toastr } from "arv-reactcomponents";
import SearchBarForm from "../SearchBarForm";
import SuggestionList from "../SuggestionList";
import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";

@withRouter
@inject("ProductStore", "CommonStore")
@observer
class SearchBar extends Component {
  static trackToggleSearch(isDesktop) {
    Analytics.trackEvent({
      action: Event.action.SEARCH_CLICK,
      label: Event.label.getSource(window.pageType),
      category: isDesktop
        ? Event.category.TOP_MENU_NAVIGATION
        : Event.category.MOBILE_TOPNAV,
    });
  }
  constructor(props) {
    super(props);
    this.state = {
      query: Utils.getUrlParameter(this.props.location.search, "q") || "",
      searchActive: false,
      searchHistory:
        Utils.localStorage.getItem(
          `localSearchHistory_${this.brandid || "nw"}`,
        ) || [],
      modalActive: false,
    };
    this.buttonActions = this.buttonActions.bind(this);
    this.toggleDropDown = this.toggleDropDown.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.triggerSearch = this.triggerSearch.bind(this);
    this.innerContents = this.innerContents.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.validateSearch = this.validateSearch.bind(this);
  }
  get brandid() {
    return lodashGet(this, "props.CommonStore.brandDetails.id", null);
  }
  get getSuggestions() {
    const { query, searchHistory } = this.state;
    const suggestionsObj = JSON.parse(
      process.env.REACT_APP_SEARCHSUGGESTIONS || "{}",
    );
    const initArray = [
      {
        title: HEADER.SEARCHBAR_RECENTS_HEADING,
        list: searchHistory,
      },
      {
        title: HEADER.SEARCHBAR_SUGGESTIONS_HEADING,
        list:
          (this.brandid && suggestionsObj[this.brandid]) ||
          (!this.brandid && suggestionsObj.nw) ||
          [],
      },
    ];
    // const normalisedQuery = query && query.toLocaleLowerCase();
    // return initArray.map(item => {
    //   const newItem = item;
    //   newItem.list = item.list.filter(
    //     subitem =>
    //       !query ||
    //       (subitem &&
    //         subitem.toLocaleLowerCase().indexOf(normalisedQuery) > -1),
    //   );
    //   return newItem;
    // });
    return initArray;
  }
  componentDidMount() {
    this.validateSearch();
  }
  validateSearch() {
    const {
      location: { pathname },
    } = this.props;
    if (pathname === "/noresults") {
      const { searchHistory } = this.state;
      searchHistory.splice(0, 1);
      this.setState({ searchHistory, query: "" });
      Utils.localStorage.setItem(
        `localSearchHistory_${this.brandid || "nw"}`,
        searchHistory,
      );
    }
  }
  toggleModal(bool) {
    const { isDesktop } = this.props.CommonStore;
    if (bool) {
      SearchBar.trackToggleSearch(isDesktop);
    }
    this.props.searchBarStatus(bool);
    this.setState({ modalActive: bool, query: "" });
  }
  triggerSearch() {
    const { query, searchHistory } = this.state;
    if (window.pageType === pageType.listing) {
      Analytics.trackEvent({
        action: query
          ? Event.action.REPEAT_SEARCH
          : Event.action.BLANK_QUERY_ERROR,
        label: Event.label.getSearchQuery(query),
        category: Event.category.SEARCH,
      });
    } else {
      Analytics.trackEvent({
        action: query
          ? Event.action.QUERY_ENTER
          : Event.action.BLANK_QUERY_ERROR,
        label: Event.label.getSearchQuery(query),
        category: Event.category.SEARCH,
      });
    }
    if (!query) {
      Toastr.showToastr({
        className: "nwc-toastr-list-danger nw-toastr",
        message: HEADER.SEARCHBAR_INVAIDSEARCHMESSAGE,
        timeout: 3000,
      });
      return;
    }
    const index = searchHistory.findIndex(
      item => item.toLocaleLowerCase() === query.toLocaleLowerCase(),
    );
    if (index > -1) {
      searchHistory.splice(index, 1);
    }
    searchHistory.unshift(query);
    const strippedSearchHistory = searchHistory.slice(0, 5);
    this.setState({ modalActive: false });
    Utils.localStorage.setItem(
      `localSearchHistory_${this.brandid || "nw"}`,
      strippedSearchHistory,
    );
    window.location.href = `${window.location.origin}/search?q=${query}`;
    // window.scrollTo(0, 0);
    // this.props.ProductStore.clearProductData();
    // this.props.history.push(`/search?q=${query}`);
  }
  toggleDropDown(bool) {
    const { isDesktop } = this.props.CommonStore;
    if (bool) {
      SearchBar.trackToggleSearch(isDesktop);
    }
    const {
      location: { pathname },
    } = this.props;
    this.setState({
      searchActive: bool,
      query:
        !bool &&
        Utils.getUrlParameter(window.location.href, "q") !== this.state.query &&
        pathname !== "/noresults"
          ? Utils.getUrlParameter(this.props.location.search, "q") || ""
          : this.state.query,
    });
    if (isDesktop) {
      this.props.searchBarStatus(bool);
    }
  }
  buttonActions(side) {
    const { isDesktop } = this.props.CommonStore;
    if (side === "submit") {
      this.triggerSearch();
    } else if (isDesktop) {
      if (!this.state.searchActive && side === "left") {
        this.toggleDropDown(true);
      }
      if (this.state.searchActive && side === "left") {
        this.triggerSearch();
      }
      if (this.state.searchActive && side === "right") {
        this.toggleDropDown(false);
        Analytics.trackEvent({
          action: Event.action.SEARCH_CLOSE,
          label: Event.label.getSource(window.pageType),
          category: Event.category.SEARCH,
        });
      }
    } else if (side === "left") {
      this.toggleModal(false);
      Analytics.trackEvent({
        action: Event.action.SEARCH_CLOSE,
        label: Event.label.getSource(window.pageType),
        category: Event.category.SEARCH,
      });
    } else {
      this.triggerSearch();
    }
  }
  selectItem(item, trigger) {
    this.setState({ query: item }, () => {
      if (trigger) {
        this.triggerSearch();
      }
    });
  }

  innerContents() {
    const { searchActive, query } = this.state;
    const { className, shrunkView } = this.props;
    return (
      <div
        className={`nw-searchbar-container ${className} ${((searchActive ||
          !shrunkView) &&
          "show-border") ||
          ""}`}
      >
        <SearchBarForm.component
          searchActive={searchActive}
          buttonActions={this.buttonActions}
          shrunkView={shrunkView}
          toggleDropDown={this.toggleDropDown}
          query={query}
          selectItem={this.selectItem}
        />
        {(!query && (
          <SuggestionList.component
            active={searchActive}
            list={this.getSuggestions}
            selectItem={this.selectItem}
            query={query}
          />
        )) ||
          null}
      </div>
    );
  }
  render() {
    const { isDesktop } = this.props.CommonStore;
    if (isDesktop) {
      return this.innerContents();
    }
    return (
      <Fragment>
        <Button
          className="nw-searchbar-mobilebutton"
          onClick={() => this.toggleModal(true)}
        >
          <i className="icomoon-search3" />
        </Button>
        <Modal
          isOpen={this.state.modalActive}
          onClose={() => this.toggleModal(false)}
          className="nw-searchbar-modal"
        >
          {this.innerContents()}
        </Modal>
      </Fragment>
    );
  }
}
SearchBar.wrappedComponent.defaultProps = {
  className: "",
  shrunkView: true,
  searchBarStatus: Utils.noop,
};

SearchBar.wrappedComponent.propTypes = {
  className: PropTypes.string,
  searchBarStatus: PropTypes.func,
  ProductStore: PropTypes.shape({
    clearProductData: PropTypes.func.isRequired,
  }).isRequired,
  shrunkView: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("ProductStore", "CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: SearchBar.wrappedComponent,
  component: SearchBar,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/molecules/SearchBar/index.js